/// <amd-module name="SuiteCommerce.Blog.LatestPosts.Slide.Model.ts"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.LatestPosts.Slide.Model.ts", ["require", "exports", "SuiteCommerce.Blog.Post.Model"], function (require, exports, Post_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LatestPostsSlideModel = void 0;
    var LatestPostsSlideModel = /** @class */ (function (_super) {
        __extends(LatestPostsSlideModel, _super);
        function LatestPostsSlideModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(LatestPostsSlideModel.prototype, "isActive", {
            get: function () {
                return this.get('isActive');
            },
            set: function (isActive) {
                this.set('isActive', isActive);
            },
            enumerable: false,
            configurable: true
        });
        return LatestPostsSlideModel;
    }(Post_Model_1.PostModel));
    exports.LatestPostsSlideModel = LatestPostsSlideModel;
});
